import {
	type CollectibleAuctionOneRefined,
	type CollectibleAuctionPostBidStatus,
	type CollectibleCollectibleRefined,
	type CollectibleTag,
	type Mutate
} from '@capsicum/common';

export const enum AuctionStatus {
	ACTIVE = 'active',
	CURRENT = 'current',
	FINISHED = 'finished',
	OWN = 'own',
	STARTING = 'starting',
	WINNING = 'winning',
	WON = 'won'
}

export const enum AuctionAttributes {
	MINUTE = 'Minute',
	SCORE = 'Score',
	SIGNED = 'signed',
	WORN = 'worn'
}

export const enum PostBidErrors {
	BID_WARS = 'bidWars',
	COUNTRY_NOT_SUPPORTED = 'countryNotSupported',
	LATE_TO_PARTY = 'lateToParty',
	NOT_ALLOWED_TO_PLACE_BID = 'notAllowedToPlaceBid'
}

export const PostBidErrorsEnum = {
	// Not allowed to place bid on this auction.
	'111c77dc-1842-48b3-a165-a377220ab338': 'lateToParty',
	// Provided bid amount is below minimum bid threshold.
	'480a178a-d5f6-486b-919a-868a9bd82b49': 'bidWars',
	// Not enough funds in balance - may be handled in the future, for now we display BE error message.
	'4a0e0de90-efc5-4bdc-bf08-0c964f908271': null,
	// Something went wrong, please retry later or contact customer support.
	'e8400d52-7998-43e4-972e-0a7111a82bac': 'notAllowedToPlaceBid'
};

export type CollectibleWithImage = Mutate<
	CollectibleAuctionOneRefined,
	'collectible',
	CollectibleCollectibleRefined & { providerImages?: Array<string>; type?: string }
>;

export type AuctionTagsType = {
	auctionData: CollectibleWithImage | undefined;
	hasIcons?: boolean;
	isBall?: boolean;
	sortedTags: Array<CollectibleTag> | undefined;
};

export type WebSocketPayload = {
	payload: {
		auctionId: string;
		bidId: string;
		bidStatus: CollectibleAuctionPostBidStatus;
		chilizUserId: string;
	};
};

export type BidStatusCardProps = {
	chzRate: number;
	chzShortCode: string;
	fiatShortCode: string;
	isActive: boolean;
	isOwnBid: boolean;
	priceCurrentBid: number;
	priceCurrentBidChz?: number;
	priceNextBid?: number;
};

export type AxiosErrorData = {
	code: string;
	is_silent: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	meta: Record<string, any>;
	status: number;
	title: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	translations: Record<string, any>;
};

export enum AuctionBidStatusEnum {
	Accepted = 'accepted',
	Outbid = 'outbid'
}
